/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy Counselor API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PutPrescriptionSharingAgreementResponseTypename = "PutPrescriptionSharingAgreementResponse" as const;

/**
 *
 * @export
 * @interface PutPrescriptionSharingAgreementResponse
 */
export interface PutPrescriptionSharingAgreementResponse {
  /**
   *
   * @type {boolean}
   * @memberof PutPrescriptionSharingAgreementResponse
   */
  isPrescriptionSharingAgreed?: boolean;
  /**
   * Resource type name
   * @type {string}
   * @memberof PutPrescriptionSharingAgreementResponse
   */
  readonly __typename?: string;
}

export function PutPrescriptionSharingAgreementResponseFromJSON(json: any): PutPrescriptionSharingAgreementResponse {
  return PutPrescriptionSharingAgreementResponseFromJSONTyped(json, false);
}

export function PutPrescriptionSharingAgreementResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PutPrescriptionSharingAgreementResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PutPrescriptionSharingAgreementResponseTypename,

    isPrescriptionSharingAgreed: !exists(json, "is_prescription_sharing_agreed")
      ? undefined
      : json["is_prescription_sharing_agreed"],
  };
}

export function PutPrescriptionSharingAgreementResponseToJSON(
  object?: PutPrescriptionSharingAgreementResponse | null
): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    is_prescription_sharing_agreed: value.isPrescriptionSharingAgreed,
  };
}
